
import React from "react";
import CoachingView from "../components/Coaching";
import { SalesPageToolSet } from "./SalesPageToolSet";


const CoachingContainer = (props) => {

    const [tool,setTool] = React.useState({});

    

    React.useEffect(()=>{
        if(props.match.params.id){
            let filteredTool =  SalesPageToolSet.find(value=>value.id === parseInt(props.match.params.id))
            setTool(filteredTool)
        }

    },[props.match.params.id])


    return (
        <>
            <CoachingView tool = {tool} />
        </>
    );
};

export default CoachingContainer;

